import * as _ from 'lodash';
import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../globals';
import Button from '../generic/Button/Button';
import Card from '../generic/Card/Card';
import Flex from '../generic/Flex';
import List from '../generic/List';

const OrgInfoCard: VoidFunctionComponent = () => {
  const [isCopied, setIsCopied] = useState(false);
  const keysToShow = [
    'id',
    'title',
    'access_level',
    'stripe_plan',
    'security_enabled',
    'quality_policy_enabled',
    'isInternal',
    'updatedAt',
    'createdAt',
  ];

  const handleCopyToClipboard = async (): Promise<void> => {
    const orgInfo = Object.entries(_.pick(window.user?.organization, keysToShow))
      .map(([key, val]) => `${key}: ${(val || '').toString()}`)
      .join('\n');

    await navigator.clipboard.writeText(orgInfo);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>
        <Flex direction="row" align="center" justify="space-between">
          <div>Organization Info</div>
          <Button onClick={handleCopyToClipboard} size="micro" type="outline">
            {isCopied ? 'Copied!' : 'Copy'}
          </Button>
        </Flex>
      </Card.Header>
      <Card.Content>
        <List isBorderless>
          <List.Body hasPadding={false}>
            {Object.entries(_.pick(window.user?.organization, keysToShow)).map(([key, val]) => (
              <List.Row
                key={key}
                hasTightPadding
                hasTightVerticalPadding
                isInteractive={false}
                left={<b>{key}</b>}
                right={<span>{(val || '').toString()}</span>}
              />
            ))}
          </List.Body>
        </List>
      </Card.Content>
    </Card>
  );
};

export default OrgInfoCard;
